import { ADD_MENU, CLEAR_MENU, SET_IS_COLLAPSE } from "../mutation-types";
import {
  getMenuData,
  createMenu,
  editMenu,
  getMenuInfo,
  deleteMenu
} from "@/service/menuService";
const menu = {
  state: {
    // 菜单的数组
    menuList: [],
    // 菜单是否收起
    isCollapse: false
  },

  getters: {},

  mutations: {
    /**
     * 添加页面左侧的menu菜单
     * @param state
     * @param menuList Array 菜单数组
     */
    [ADD_MENU]: (state, menuList) => {
      state.menuList = menuList;
    },
    /**
     * 清空菜单
     * @param state
     */
    [CLEAR_MENU]: state => {
      state.menuList = [];
    },
    /**
     * 设置menu菜单栏 是否展开
     * @param state
     * @param isCollapse boolean 是否展开
     */
    [SET_IS_COLLAPSE]: (state, isCollapse) => {
      state.isCollapse = isCollapse;
    }
  },
  actions: {
    /**
     * 获取menu列表
     */
    getMenuData(store, info) {
      return new Promise((resolve, reject) => {
        getMenuData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建menu
     * @param {*} store
     * @param {*} data
     */
    createMenu(store, data) {
      return new Promise((resolve, reject) => {
        createMenu(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取menu详情
     * @param {*} store
     * @param {*} id
     */
    getMenuInfo(store, id) {
      return new Promise((resolve, reject) => {
        getMenuInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑menu
     * @param {*} store
     * @param {*} data
     */
    editMenu(store, data) {
      return new Promise((resolve, reject) => {
        editMenu(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除menu
     * @param {*} store
     * @param {*} id
     */
    deleteMenu(store, id) {
      return new Promise((resolve, reject) => {
        deleteMenu(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default menu;



// WEBPACK FOOTER //
// ./src/store/modules/menu.js